import { Dealer, SubtractiveGenerator } from 'game-logic';
import { getGameMetrics } from '../helpers/game-metrics';

export class LocalDealer implements Dealer<number> {
  constructor(private readonly secrets: number[]) {}

  public async discloseSecrets(indexes: number[], _gameHash: string): Promise<number[]> {
    try {
      return Promise.resolve(indexes.map((index) => this.secrets[index]));
    } catch (error) {
      return Promise.reject([]);
    }
  }

  public static makeRandom(logicVersion: number): LocalDealer {
    const seed = Math.floor(new Date().getTime() / 1000);
    const random = new SubtractiveGenerator(seed);
    const gameMetrics = getGameMetrics(logicVersion);

    const secrets: number[] = [];
    for (let i = 0; i < gameMetrics.MaxStage; i++) {
      secrets.push(random.next());
    }
    return new LocalDealer(secrets);
  }
}
